import React from 'react';
import { Grid, Typography, Box} from '@mui/material';
import homestyles from  "../css/homestyles.module.css"

// TODO: Modify Box height if necessary

const About = () => {
    return (
        <Box sx={{margin: 2, height: '100vh'}}>
            <Grid container spacing={1} style={{marginTop: 2}} className={homestyles['primary-background']}>
                <Grid item xs={0} sm={0} md={2} lg={2} xl={2}/>
                <Grid item container direction={'row'} xs={12} sm={12} md={7} lg={7} xl={7} spacing={1}>
                    <Typography variant='h3'>ABOUT</Typography>
                </Grid>
            </Grid>
        </Box>
        
    );
}

export default About;